"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var ChipItem_1 = __importDefault(require("@components/DropdownWithSearch/ChipItem"));
var DropdownItem_1 = __importDefault(require("@components/DropdownWithSearch/DropdownItem"));
function DropdownWithSearch(_a) {
    var data = _a.data, buttonText = _a.buttonText, onChange = _a.onChange, componentClass = _a.componentClass, iconText = _a.iconText, getItemLabel = _a.getItemLabel, getItemId = _a.getItemId, dropDownTitle = _a.dropDownTitle, statusClass = _a.statusClass, isDisabled = _a.isDisabled, dropDirectionClass = _a.dropDirectionClass, value = _a.value, dataCy = _a.dataCy, multiselect = _a.multiselect, className = _a.className;
    var _b = __read((0, react_1.useState)(''), 2), searchText = _b[0], setSearchText = _b[1];
    var _c = __read((0, react_1.useState)(false), 2), isOpened = _c[0], setIsOpened = _c[1];
    var _d = __read((0, react_1.useState)(null), 2), focusedItem = _d[0], setFocusedItem = _d[1];
    var onChangeMultiSelect = function (item) {
        if (multiselect === true) {
            if (Array.isArray(value) && value.includes(item)) {
                onChange(value.filter(function (valueItem) { return getItemId(valueItem) !== getItemId(item); }));
            }
            else {
                onChange(__spreadArray(__spreadArray([], __read((Array.isArray(value) ? value : [])), false), [item], false));
            }
        }
    };
    (0, react_1.useEffect)(function () {
        var handleKeyDown = function (event) {
            var keys = ['ArrowDown', 'ArrowUp', 'Enter', 'Escape'];
            if (!keys.includes(event.key) || !isOpened || isDisabled)
                return;
            switch (event.key) {
                case 'ArrowDown':
                    setFocusedItem(function (prev) { return (prev === null ? 0 : Math.min(prev + 1, data.length - 1)); });
                    break;
                case 'ArrowUp':
                    setFocusedItem(function (prev) { return (prev === null ? 0 : Math.max(prev - 1, 0)); });
                    break;
                case 'Enter':
                    if (focusedItem !== null) {
                        onChangeMultiSelect(data[focusedItem]);
                    }
                    break;
                case 'Escape':
                    setSearchText('');
                    setFocusedItem(null);
                    break;
                default:
                    break;
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return function () {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [focusedItem, data, onChange, isOpened, isDisabled]);
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)("".concat(className), !multiselect && "eva-drop-down-with-search dropdrown", multiselect && 'eva-multi-select-with-search', componentClass && componentClass, statusClass && statusClass, dropDirectionClass && dropDirectionClass, isOpened && 'open eva-keyboard-focused', isDisabled && 'is-disabled'), onMouseEnter: function () { return !isDisabled && setIsOpened(true); }, onMouseLeave: function () { return !isDisabled && setIsOpened(false); }, onFocus: function () { return setIsOpened(true); }, onBlur: function () { return setIsOpened(false); }, tabIndex: -1 },
        react_1.default.createElement("button", { type: "button", "data-cy": dataCy, className: (0, clsx_1.default)('btn', !multiselect && 'eva-decision-button', multiselect && 'multi-select-button', isOpened && 'open') },
            multiselect && Array.isArray(value) && value && value.length > 0 && (react_1.default.createElement(react_1.default.Fragment, null, value.map(function (item) {
                return (react_1.default.createElement(ChipItem_1.default, { key: getItemId(item), item: item, onRemove: function () {
                        onChangeMultiSelect(item);
                    }, getItemLabel: getItemLabel, dataCy: dataCy }));
            }))),
            iconText && react_1.default.createElement("span", { className: "eva-shortcut-icon" }, iconText),
            (!multiselect || !value || (Array.isArray(value) && value.length === 0)) && (react_1.default.createElement("span", { "data-cy": "".concat(dataCy, "-placeholder"), className: (0, clsx_1.default)(!multiselect && 'eva-button-text', multiselect && 'placeholder') }, buttonText)),
            !multiselect ? react_1.default.createElement("span", { className: "implioicons-arrow-3-down eva-dropdown-caret" }) : react_1.default.createElement("span", { className: "caret" })),
        isOpened && (react_1.default.createElement("ul", { className: "dropdown-menu", role: "menu" },
            react_1.default.createElement("p", { className: "drop-down-menu-title" }, dropDownTitle),
            react_1.default.createElement("div", { className: (0, clsx_1.default)("eva-dropdown-container", data.length === 0 && 'empty-list') }, data
                .filter(function (item) { return getItemLabel(item).toLowerCase().includes(searchText.toLowerCase()); })
                .map(function (item, index) { return (react_1.default.createElement(DropdownItem_1.default, { key: index, item: item, value: value, setIsOpened: setIsOpened, onChange: onChange, getItemLabel: getItemLabel, getItemId: getItemId, onChangeMultiSelect: onChangeMultiSelect, multiselect: multiselect, dataCy: dataCy, isFocused: focusedItem === index })); })),
            react_1.default.createElement("div", { className: "dropdown-menu-input-container" },
                react_1.default.createElement("span", { className: "dropdown-menu-input-container-icon implioicons-search" }),
                react_1.default.createElement("input", { className: "search-input", autoFocus: true, value: searchText, onChange: function (e) { return setSearchText(e.target.value); } })),
            react_1.default.createElement("div", { className: "eva-dropdown-arrow" }),
            react_1.default.createElement("div", { className: "eva-dropdown-arrow-cover" }),
            react_1.default.createElement("div", { className: "eva-dropdown-hover-area" })))));
}
exports.default = DropdownWithSearch;
